import React from 'react';

import {
  Breakpoints,
  Container,
  IntegratorRoot,
  Layout,
  styled,
  ThemeProvider,
} from '@volkswagen-onehub/components-core';
import {
  Content,
  FaContentServiceV1,
} from '@volkswagen-onehub/fa-content-service';
import { FeatureAppLoader } from '@feature-hub/react';
import { History } from 'history';

import { appsCommonsJS, appsUMD } from './app-constants';
import {
  contentFeatureAppMap,
  getConfigsFeatureApp,
} from './feature-app-helpers';
import { ModelsCarouselIntegratorOptions } from './create-options-from-query-params';

import {
  mockedCompacts,
  mockedElectricVehicles,
  mockedSedans,
  mockedSuvs,
} from './mock-content';

const StyledContainer = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
`;

interface IntegratorProps extends ModelsCarouselIntegratorOptions {
  readonly history: History;
}

export const Integrator = ({
  baseUrl,
  history,
  ssr,
  featureAppName = 'default',
  ...props
}: IntegratorProps): JSX.Element => {
  const featureAppConfig = getConfigsFeatureApp({
    ...props,
    featureAppName,
  });

  return (
    <IntegratorRoot>
      <ThemeProvider variant='v26'>
        <Layout
          allowOverflowingContent
          appearance={{
            [Breakpoints.default]: [
              { name: '.', columns: 0 },
              { name: 'a', columns: 24 },
              { name: '.', columns: 0 },
            ],
          }}
        >
          <Container
            wrap="always"
            padding={{
              top: 'static0',
              bottom: 'static350',
            }}
            gutter="static500"
          >
            <StyledContainer>
              <FeatureAppLoader
                featureAppId="models-carousel"
                baseUrl={baseUrl}
                src={appsUMD[featureAppName]}
                serverSrc={
                  ssr ? appsCommonsJS[featureAppName] : undefined
                }
                config={featureAppConfig}
                beforeCreate={({ featureServices }) => {
                  const content: Content =
                    contentFeatureAppMap[featureAppName];

                  if (content) {
                    (
                      featureServices[
                      'fa-content-service'
                      ] as FaContentServiceV1
                    ).content = content;
                  }
                  (
                    featureServices[
                    'fa-content-service'
                    ] as FaContentServiceV1
                  ).content = {
                    sedans: mockedSedans,
                    suvs: mockedSuvs,
                    compacts: mockedCompacts,
                    electric_vehicles: mockedElectricVehicles,
                    categoryOrder: ["suvs", "compacts", "sedans", "electric_vehicles"]
                  };
                }}
              />
            </StyledContainer>
          </Container>
        </Layout>
      </ThemeProvider>
    </IntegratorRoot>
  );
};
